<template>
  <v-container v-if="tableData.length > 0" fluid class="px-2">
    <v-app-bar dense dark fixed app color="brown darken-1" v-if="!$store.state.auth.user">
      <v-spacer />

      <v-toolbar-items>
        <v-btn text to="/">
          <span class="hidden-xs-only">LOGIN</span>
          <v-icon large>{{ mdiLogin }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-data-table
      :items="tableData"
      item-key="id"
      :headers="headers"
      :height="$store.state.windowSize.y - 140"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      dense
      :loading="loaderStatus"
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr @click="((plannedVisitDetail = true), (plannedVisitSelected = item))">
          <td>{{ item.name + ' ' + item.surname }}</td>
          <td>{{ item.employeeName + ' ' + item.employeeSurname }}</td>
          <td>{{ formatDateTZ(item.timearrive, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
          <td class="d-none d-sm-table-cell">
            {{ formatDateTZ(item.timedeparture, item.timezone, $store.state.auth.df.dateYearTime) }}
          </td>
          <td>
            <v-tooltip v-if="item.approvalstatus == 0" bottom :open-delay="1000">
              <template v-slot:activator="{ on, attrs }">
                <v-simple-checkbox v-on="on" v-bind="attrs" v-model="item.checked" />
                <!--Workaround - for some reason icon refresh does not work correctly without dummy icon -->
                <v-icon v-show="false" v-on="on" v-bind="attrs" />
              </template>
              <span>{{ $t('label.approvalWaiting') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 1" bottom :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="green" v-on="on" v-bind="attrs">{{ mdiCheckBold }}</v-icon>
              </template>
              <span>{{ $t('label.approved') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 2" bottom :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="red" v-on="on" v-bind="attrs">{{ mdiCloseThick }}</v-icon>
              </template>
              <span>{{ $t('label.declined') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 10" bottom :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="blue" v-on="on" v-bind="attrs">{{ mdiAccountArrowLeft }}</v-icon>
              </template>
              <span>{{ $t('label.inObject') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.approvalstatus == 11" bottom :open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="grey darken-2" v-on="on" v-bind="attrs">{{ mdiAccountArrowRight }}</v-icon>
              </template>
              <span>{{ $t('label.visitClosed') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-row class="my-1">
      <v-col cols="2">
        <v-btn
          v-if="tableData.length > 0"
          color="colorSave"
          block
          @click="approveMultiple(1)"
          :disabled="!tableData.some((item) => item.checked)"
          >{{ $t('label.approve') }}
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          v-if="tableData.length > 0"
          color="colorDelete"
          block
          @click="approveMultiple(2)"
          :disabled="!tableData.some((item) => item.checked)"
          >{{ $t('label.reject') }}
        </v-btn>
      </v-col>
      <v-col cols="7" />
      <v-col cols="1" class="text-right">
        <v-simple-checkbox
          v-if="tableData.length > 0"
          v-model="multiselect"
          :disabled="!tableData.some((item) => item.approvalstatus == 0)"
          @click="tableData.forEach((v) => (v.approvalstatus == 0 ? (v.checked = multiselect) : (v.checked = false)))"
          class="mr-8"
        >
        </v-simple-checkbox>
      </v-col>
    </v-row>
    <!--DIALOGS----------------------------------------------------------------------->
    <v-dialog v-model="plannedVisitDetail" width="900">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.approval') }}
          <v-spacer /><v-icon large @click="plannedVisitDetail = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-sheet style="overflow-y: auto; overflow-x: hidden" :height="$store.state.windowSize.y - 250" :max-height="460">
          <v-card-text class="pa-3">
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.visiting') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.employeeSurname }} {{ plannedVisitSelected.employeeName }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedBy') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.plannerName }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.visitor') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.name }} {{ plannedVisitSelected.surname }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.document') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ getDocumentType(plannedVisitSelected.documenttype) }} - {{ plannedVisitSelected.documentno }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.phone') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.phone }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.email') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.email }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.company') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>{{ plannedVisitSelected.companyname }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.car') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>{{ plannedVisitSelected.carplate }} - {{ plannedVisitSelected.cartype }} {{ plannedVisitSelected.carcolor }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedArrival') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3 v-if="plannedVisitSelected.timearrive">
                  <b>{{
                    formatDateTZ(plannedVisitSelected.timearrive, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime)
                  }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.plannedDeparture') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3 v-if="plannedVisitSelected.timearrive">
                  <b>{{
                    formatDateTZ(plannedVisitSelected.timedeparture, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime)
                  }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $tc('label.area') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.areaName }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1" cols="4">
                <h3>{{ $t('label.note') }}</h3>
              </v-col>
              <v-col class="py-1" cols="8">
                <h3>
                  <b>{{ plannedVisitSelected.note }}</b>
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="plannedVisitSelected.approvalstatus < 10">
              <v-col>
                <v-text-field v-model="plannedVisitSelected.approvalnote" :label="$t('label.note')"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-sheet>
        <v-divider />
        <v-card-actions v-if="plannedVisitSelected.approvalstatus < 10">
          <v-col cols="6">
            <v-btn block color="green" @click="approveVisit(1)">
              {{ $tc('label.approve') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block color="red" @click="approveVisit(2)">
              {{ $tc('label.reject') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import {
  mdiHelp,
  mdiCheckBold,
  mdiCloseThick,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiAccountArrowLeft,
  mdiAccountArrowRight,
  mdiLogin,
} from '@mdi/js';

export default Vue.extend({
  name: 'employee-approval',
  data: () => ({
    activeTab: 0,
    tableData: [],
    loaderStatus: false,
    pvUUID: '',
    listDocumentTypes: [],
    listEmployees: [
      {
        id: 0,
        fullName: '',
      },
    ],
    plannedVisitDetail: false,
    plannedVisitSelected: {
      approvalstatus: 0,
      approvalnote: '',
      name: '',
      surname: '',
      employeeName: '',
      employeeSurname: '',
      plannerName: '',
      documenttype: '',
      documentno: '',
      phone: '',
      email: '',
      companyname: '',
      carplate: '',
      cartype: '',
      carcolor: '',
      timearrive: '',
      timedeparture: '',
      areaName: '',
      note: '',
      timezone: '',
      checked: false,
    },
    multiselect: false,
    mdiHelp: mdiHelp,
    mdiCheckBold: mdiCheckBold,
    mdiCloseThick: mdiCloseThick,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiClose: mdiClose,
    mdiAccountArrowLeft: mdiAccountArrowLeft,
    mdiAccountArrowRight: mdiAccountArrowRight,
    mdiLogin: mdiLogin,
  }),
  computed: {
    headers: function () {
      return [
        { text: this.$i18n.tc('label.visitor'), value: 'name' },
        { text: this.$i18n.tc('label.visiting'), value: 'employeeName' },
        { text: this.$i18n.tc('label.arrival'), value: 'timearrive' },
        { text: this.$i18n.tc('label.departure'), value: 'timedeparture' },
        { text: this.$i18n.tc('label.state'), sortable: false, width: '48px' },
      ];
    },
  },
  mounted() {
    this.pvUUID = this.$route.query.uuid as string;
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      this.loaderStatus = true;
      axios
        .get(`/api/plannedvisits/approvallink/${this.$route.query.uuid}`)
        .then((response) => {
          this.$i18n.locale = response.data.lang;
          for (const record of response.data.visits) {
            record.checked = false;
            this.multiselect = false;
          }
          this.tableData = response.data.visits;
          this.listDocumentTypes = response.data.documentTypes;
          this.loaderStatus = false;
        })
        .catch((err) => {
          if (err.response.data.message === 'uuidNotFound') {
            this.$store.commit('globalMessage', 'NOT FOUND');
          } else {
            this.$store.commit('globalMessage', 'ERROR');
          }
          this.loaderStatus = false;
        });
    },
    approveMultiple(approvalStatus: number) {
      let selectedVisits = this.tableData.filter((item: any) => item.checked);
      selectedVisits = selectedVisits.map((item: any) => {
        item.approvalstatus = approvalStatus;
        return item;
      });
      axios
        .patch(`/api/plannedvisits/approvallink/${this.pvUUID}`, selectedVisits)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    approveVisit(approvalStatus: number) {
      this.plannedVisitSelected.approvalstatus = approvalStatus;
      axios
        .patch(`/api/plannedvisits/approvallink/${this.pvUUID}`, [this.plannedVisitSelected])
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.plannedVisitDetail = false;
        });
    },
    getDocumentType(documenttype: string) {
      let document: any;
      for (document of this.listDocumentTypes) {
        if (documenttype === document.type) {
          return document.name;
        }
      }
      return '';
    },
    selectMultiple() {
      this.tableData.forEach((item) => (item.approvalstatus == 0 ? (item.checked = this.multiselect) : (item.checked = false)));
    },
    formatDateTZ(date: string, timeZone: string, format: string) {
      return this.$moment(date).tz(timeZone).format(format);
    },
  },
});
</script>
